import React from 'react';

interface DigitalSignatureProps {
  name: string;
  role: string;
  date?: string;
  titlePrefix?: string;
  signatureFile?: string;
}

// Map user names/roles to signature files
export function resolveSignatureFile(name: string, role: string): string {
  const lower = (name + ' ' + role).toLowerCase();
  if (lower.includes('dewi') || lower.includes('aminah') || lower.includes('admin - kasir') || lower.includes('admin - tagihan')) {
    return '/signatures/dewi-lestari.svg';
  }
  if (lower.includes('hendra') || lower.includes('finance manager') || lower.includes('manager')) {
    return '/signatures/hendra-wijaya.svg';
  }
  if (lower.includes('budi') || lower.includes('owner')) {
    return '/signatures/budi-santoso.svg';
  }
  if (lower.includes('siti rahma') || lower.includes('purchaser')) {
    return '/signatures/siti-rahma.svg';
  }
  if (lower.includes('mitra') || lower.includes('cv ') || lower.includes('pt ') || lower.includes('konveksi')) {
    return '/signatures/mitra-konveksi.svg';
  }
  return '/signatures/admin.svg';
}

export const DigitalSignatureBox: React.FC<DigitalSignatureProps> = ({
  name,
  role,
  date,
  titlePrefix,
  signatureFile,
}) => {
  const sigSrc = signatureFile || resolveSignatureFile(name, role);

  return (
    <div style={{ textAlign: 'center', width: '100%', maxWidth: 220, margin: '0 auto' }}>
      {titlePrefix && (
        <div style={{ fontSize: 11, color: '#64748B', fontWeight: 600, marginBottom: 4 }}>
          {titlePrefix}
        </div>
      )}

      {/* Signature Image Graphic */}
      <div
        style={{
          height: 60,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          padding: '2px 0',
        }}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={sigSrc}
          alt={`Tanda Tangan ${name}`}
          style={{
            maxHeight: 56,
            maxWidth: 160,
            objectFit: 'contain',
            filter: 'drop-shadow(0 1px 2px rgba(30, 64, 175, 0.15))',
          }}
        />
      </div>

      {/* Signer Name & Divider */}
      <div
        style={{
          borderTop: '1.5px solid #0F172A',
          paddingTop: 5,
          marginTop: 2,
        }}
      >
        <div style={{ fontSize: 12.5, fontWeight: 700, color: '#0F172A', lineHeight: 1.2 }}>
          {name}
        </div>
        <div style={{ fontSize: 11, color: '#64748B', marginTop: 2 }}>{role}</div>
        {date && (
          <div style={{ fontSize: 10, color: '#94A3B8', marginTop: 1 }}>
            Tgl: {date}
          </div>
        )}
      </div>
    </div>
  );
};
